import { useState } from 'react'
import { Space, TreeSelect, Button, message } from 'antd';
import { PlusCircleTwoTone, RightOutlined } from '@ant-design/icons';
import { YhBox } from "@/components/YhBox";
import { AddApplyDrawer } from './AddApplyDrawer';
import { AddNodeDrawer } from './AddNodeDrawer';
import { approvalService } from '../ApprovalService';
import { useApprovalModel } from "../approvalModel";
import { ApprovalFlowNodeFields, UserFields, UserJobFields } from '../ApprovalTypes';
import '../approval.less'

export const RightAdd = () => {

  const {
    shopTree, guid, clone,
    setAddNodeDrawer,
    setAddApplyDrawer,
    setSelectedShop,
    flowNodes, setFlowNodes,
    applyUsers, setApplyUsers,
  } = useApprovalModel()

  const [treeSelect, setTreeSelect] = useState<string[]>([]);

  const onChange = (newValue: string[]) => {
    setTreeSelect(newValue);
  };

  const addNode = (index: number) => {
    flowNodes.splice(index, 0, { "id": guid().replaceAll("-", "") });
    setFlowNodes(clone(flowNodes));
  }

  const deleteNode = (index: number) => {
    flowNodes.splice(index, 1);
    setFlowNodes(clone(flowNodes));
  }

  const addNodeDetail = (item?: ApprovalFlowNodeFields) => {
    setAddNodeDrawer({ visible: true, node: item });
  }

  const handleSubmitNode = (data: ApprovalFlowNodeFields) => {
    setFlowNodes(flowNodes.map(item => item.id == data.id ? data : item));
  }

  const handleSelectApply = (user: UserFields[]) => { }

  const onSubmit = () => {
    let flag = true;
    if (treeSelect == null || treeSelect.length == 0) {
      message.error("请选择对应门店");
      flag = false;
    }
    if (applyUsers == null || applyUsers.length == 0) {
      message.error("请选择申请人");
      flag = false;
    }
    if (flowNodes == null || flowNodes.length == 0) {
      message.error("请添加审核节点");
      flag = false;
    }
    flowNodes.map(item => {
      if (item.nodeTitle == null) {
        message.error("请完善审核节点");
        flag = false;
      }
    });

    if (flag) {
      let param = {
        shopCodes: treeSelect,
        applys: applyUsers?.map((item, index) => ({
          "applyUserCode": item.code,
          "applyUserName": item.name,
          "applyUserDuty": item.job,
          "sort": index
        })),
        nodes: flowNodes,
      }
      approvalService.insert(param).then(res => {
        if (res && res.retData == true) {
          message.success('保存成功');
          //关闭新增页、清除数据
          setSelectedShop(undefined);
          setTreeSelect([]);
          setFlowNodes([]);
          setApplyUsers([]);
        }
      }).catch(err => {
        message.error("保存失败" + err);
      })
    }
  }

  return (
    <YhBox width="360px" height="100%" title="流程配置" style={{ overflow: 'auto' }}>
      <div className="right-head">
        <TreeSelect
          showSearch
          allowClear
          style={{ width: '100%' }}
          treeCheckable={true}
          placeholder="选择对应门店"
          treeData={shopTree}
          onChange={onChange}
        />
        <div className="right-head-button">
          <Button
            type="link"
            shape="round"
            onClick={onSubmit}
          >
            保存
          </Button>
        </div>
      </div>
      <div className='node-list' >
        <div className='node' style={{ marginBottom: 30 }}>
          <div className='node-title'>申请人</div>
          <div className='node-add' onClick={() => setAddApplyDrawer(true)}>
            <div className='node-add-user'>
              {applyUsers?.length != 0 ? "" :
                <div className='node-add-user-child'>
                  <span className='node-add-user-name'>添加</span>
                </div>
              }
              {applyUsers?.map((item) =>
                <div className='node-add-user-child'>
                  <span className='node-add-user-name'>{item?.name}</span>
                </div>
              )}
            </div>
            <span className='node-add-icon'><RightOutlined /></span>
          </div>
        </div>
        <div className='node'>
          <div className='node-title'>开始</div>
          <div className='node-subtitle'>审批流程开始</div>
        </div>
        <div className='line'>
          <div className='line-button' onClick={() => addNode(0)}>
            <Space><PlusCircleTwoTone twoToneColor="blue" /></Space>
          </div>
        </div>
        {flowNodes.map((item, index) =>
          <div key={item.id}>
            <div className='node'>
              <div className='node-title'>
                <div style={{ flex: 8 }}>
                  {item && item.nodeTitle ? item.nodeTitle : '审批节点'}
                  <span style={{ color: "#7D00FD", marginLeft: 5, fontSize: 14 }}>{item.nodeType == 0 ? '审核' : item.nodeType == 1 ? '抄送' : ''}</span>
                </div>
                <span style={{ flex: 1, color: "#3333FF", fontSize: 14 }} onClick={() => deleteNode(index)}>删除</span>
              </div>
              <div className='node-add' onClick={() => addNodeDetail(item)}>
                <div className='node-add-user'>
                  <div className='node-add-user-child'>
                    <span className='node-add-user-name'>{item?.approvalUserName ? item.approvalUserName : '添加'}</span>
                    <span className='node-add-user-duty'>{item?.approvalUserDuty}</span>
                  </div>
                </div>
                <span className='node-add-icon'><RightOutlined /></span>
              </div>
            </div>
            <div className='line'>
              <div className='line-button' onClick={() => addNode(index + 1)}>
                <Space><PlusCircleTwoTone twoToneColor="blue" /></Space>
              </div>
            </div>
          </div>
        )}
        <div className='node'>
          <div className='node-title'>结束</div>
          <div className='node-subtitle'>审批流程结束</div>
        </div>
      </div>
      <AddApplyDrawer onSelectOk={handleSelectApply} />
      <AddNodeDrawer onSubmitOk={handleSubmitNode} />
    </YhBox >
  )
}